export default __webpack_public_path__ + "static/media/temp1.bd96519b.png";